import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["startButton", "display", "countdown", "progress"]
  static values = {
    seconds: { type: Number, default: 60 },
    remaining: Number,
    autoStart: { type: Boolean, default: false }
  }

  connect() {
    this.remainingValue = this.secondsValue
    this.intervalId = null

    if (this.autoStartValue) {
      this.startTimer()
    }
  }

  disconnect() {
    if (this.intervalId) {
      clearInterval(this.intervalId)
      this.intervalId = null
    }
  }

  start() {
    if (this.intervalId) return
    this.startTimer()
  }

  startTimer() {
    if (this.intervalId) return

    this.remainingValue = this.secondsValue

    if (this.hasStartButtonTarget) {
      this.startButtonTarget.classList.add("hidden")
    }
    if (this.hasDisplayTarget) {
      this.displayTarget.classList.remove("hidden")
    }

    this.updateDisplay()

    this.intervalId = setInterval(() => {
      this.remainingValue--
      this.updateDisplay()

      if (this.remainingValue <= 0) {
        this.complete()
      }
    }, 1000)
  }

  stop() {
    if (this.intervalId) {
      clearInterval(this.intervalId)
      this.intervalId = null
    }
    this.reset()
  }

  complete() {
    if (this.intervalId) {
      clearInterval(this.intervalId)
      this.intervalId = null
    }

    if (this.hasCountdownTarget) {
      this.countdownTarget.classList.add("text-green")
      this.countdownTarget.textContent = "Pronto!"
    }

    setTimeout(() => {
      this.reset()
    }, 2000)
  }

  reset() {
    this.remainingValue = this.secondsValue
    if (this.hasDisplayTarget) {
      this.displayTarget.classList.add("hidden")
    }
    if (this.hasStartButtonTarget) {
      this.startButtonTarget.classList.remove("hidden")
    }
    if (this.hasCountdownTarget) {
      this.countdownTarget.classList.remove("text-green")
    }
    if (this.hasProgressTarget) {
      this.progressTarget.style.width = "100%"
    }
  }

  updateDisplay() {
    if (!this.hasCountdownTarget || !this.hasProgressTarget) return

    const minutes = Math.floor(this.remainingValue / 60)
    const seconds = this.remainingValue % 60
    this.countdownTarget.textContent = `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`

    const progressPercent = (this.remainingValue / this.secondsValue) * 100
    this.progressTarget.style.width = `${progressPercent}%`
  }

  updateSeconds(event) {
    const newValue = parseInt(event.target.value, 10)
    if (!isNaN(newValue) && newValue > 0) {
      this.secondsValue = newValue
      this.remainingValue = newValue
    }
  }
}
